module.exports = __webpack_public_path__ + "img/z-about-img2.50c207c1.jpg";